// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__rypvd","logo":"style_logo__uM-lg","contentContainer":"style_contentContainer__-usMD"};